import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './css/Dialogs.css';
import { toast } from 'react-toastify';

const SubjectAddDialog = ({ isOpen, onClose, onSave, categories, onCreateCategory }) => {
    const { t } = useTranslation();
    const [subjectName, setSubjectName] = useState('');
    const [unitTime, setUnitTime] = useState(30);
    const [color, setColor] = useState('#' + Math.floor(Math.random() * 16777215).toString(16));
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [showCategoryAdd, setShowCategoryAdd] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [newCategoryColor, setNewCategoryColor] = useState('#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0'));

    // iOS Safari: 모달 열릴 때 배경 스크롤 방지
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            return () => { document.body.style.overflow = ''; };
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSave = () => {
        if (subjectName.trim() && selectedCategoryId) {
            onSave(subjectName.trim(), selectedCategoryId, color, unitTime);
            onClose();
        } else {
            toast.warn(t('fillAllFields'));
        }
    };

    const handleAddCategory = async () => {
        if (!newCategoryName.trim()) {
            toast.warn(t('fillAllFields'));
            return;
        }
        if (onCreateCategory) {
            const newCat = await onCreateCategory(newCategoryName.trim(), newCategoryColor);
            if (newCat) {
                setSelectedCategoryId(newCat.category_id);
                setColor(newCat.color);
            }
        }
        setNewCategoryName('');
        setNewCategoryColor('#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0'));
        setShowCategoryAdd(false);
    };

    return (
        <div className="dialog-overlay">
            <div className="dialog-box">
                <h3 className="dialog-title">{t('addSubject')}</h3>

                <div>
                    <span className="dialog-label">{t('categories')}</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px', marginBottom: '8px' }}>
                        {categories.map(category => (
                            <div
                                key={category.category_id}
                                className={`category-chip ${selectedCategoryId === category.category_id ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelectedCategoryId(category.category_id);
                                    setColor(category.color);
                                }}
                                style={selectedCategoryId === category.category_id ? {} : { borderLeft: `4px solid ${category.color}` }}
                            >
                                {category.category_name}
                            </div>
                        ))}
                        <div
                            className="category-chip"
                            style={{ cursor: 'pointer', borderStyle: 'dashed' }}
                            onClick={() => setShowCategoryAdd(!showCategoryAdd)}
                        >
                            + {t('addCategory')}
                        </div>
                    </div>
                    {showCategoryAdd && (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px' }}>
                            <input
                                type="text"
                                className="dialog-input"
                                style={{ flex: 1, marginBottom: 0 }}
                                placeholder={t('categoryName')}
                                value={newCategoryName}
                                onChange={(e) => setNewCategoryName(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleAddCategory()}
                            />
                            <input
                                type="color"
                                value={newCategoryColor}
                                onChange={(e) => setNewCategoryColor(e.target.value)}
                                style={{ width: '42px', height: '42px', padding: '2px', cursor: 'pointer', border: '1px solid #ddd', borderRadius: '4px' }}
                            />
                            <button className="btn-primary" style={{ whiteSpace: 'nowrap' }} onClick={handleAddCategory}>{t('save')}</button>
                        </div>
                    )}
                </div>

                <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{ flex: 1 }}>
                        <label className="dialog-label">{t('unitTime')} ({t('minutes')})</label>
                        <input
                            type="number"
                            min="1"
                            value={unitTime}
                            onChange={(e) => setUnitTime(e.target.value)}
                            className="dialog-input"
                        />
                    </div>

                    <div style={{ flex: 1 }}>
                        <label className="dialog-label">{t('color')}</label>
                        <input
                            type="color"
                            value={color}
                            onChange={(e) => setColor(e.target.value)}
                            className="dialog-input"
                            style={{ padding: '2px', height: '42px' }}
                        />
                    </div>
                </div>

                <div>
                    <label className="dialog-label">{t('subjectName')}</label>
                    <input
                        type="text"
                        placeholder={t('addSubject')}
                        className="dialog-input"
                        value={subjectName}
                        onChange={(e) => setSubjectName(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                    />
                </div>

                <div className="dialog-actions">
                    <button className="btn-secondary" onClick={onClose}>{t('cancel')}</button>
                    <button className="btn-primary" onClick={handleSave}>{t('save')}</button>
                </div>
            </div>
        </div>
    );
};

export default SubjectAddDialog;
